<div *ngIf="isOpen" class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
  <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] flex flex-col">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between flex-shrink-0">
      <h3 class="text-lg font-semibold text-westetics-neutral-950">{{ title }}</h3>
      <button type="button" (click)="onCancel()" class="text-gray-400 hover:text-gray-600">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Search -->
    <div class="px-6 py-3 border-b border-gray-200 bg-gray-50 flex-shrink-0">
      <div class="relative">
        <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
        <input
          type="text"
          placeholder="Buscar procedimento..."
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchChange($event)"
          class="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800">
      </div>
    </div>

    <!-- Procedure list -->
    <div class="flex-1 overflow-y-auto px-6 py-3">
      <div *ngIf="filteredProcedures.length === 0" class="text-sm text-gray-500 py-4 text-center">
        Nenhum procedimento encontrado.
      </div>
      <div *ngFor="let proc of filteredProcedures" class="flex items-center gap-3 py-2 border-b border-gray-100 last:border-b-0">
        <input
          type="checkbox"
          [id]="'modal-proc-' + proc.value"
          [checked]="isSelected(proc.value)"
          (change)="onToggle(proc.value, $event)"
          class="w-4 h-4 text-westetics-purple-800 border-gray-300 rounded focus:ring-westetics-purple-800">
        <label [for]="'modal-proc-' + proc.value" class="text-sm text-gray-700 cursor-pointer flex-1">{{ proc.label }}</label>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 flex items-center justify-between flex-shrink-0">
      <span class="text-sm text-gray-600">{{ tempSelected.size }} selecionado(s)</span>
      <div class="flex gap-3">
        <button
          type="button"
          (click)="onCancel()"
          class="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 text-sm font-medium">
          Cancelar
        </button>
        <button
          type="button"
          (click)="onConfirm()"
          class="px-4 py-2 bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 text-sm font-medium">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>
